import api from './api';

const base = '/admin/platform';

export const adminPlatformAPI = {
  getStatus: () => api.get(`${base}/status`),
  getFiwareSettings: () => api.get(`${base}/fiware/settings`),
  saveFiwareSettings: (payload: Record<string, unknown>) => api.put(`${base}/fiware/settings`, payload),
  testFiwareConnection: (payload?: Record<string, unknown>) =>
    api.post(`${base}/fiware/test-connection`, payload || {}),
  queryEntities: (params: { type?: string; q?: string; limit?: number }) =>
    api.get(`${base}/fiware/entities`, { params }),
  getEntity: (id: string) => api.get(`${base}/fiware/entities/${id}`),
  searchUsers: (q: string) => api.get(`${base}/fiware/search-users`, { params: { q } }),
  searchBusinesses: (q: string) => api.get(`${base}/fiware/search-businesses`, { params: { q } }),
  syncUser: (id: string) => api.post(`${base}/fiware/sync/user/${id}`),
  syncBusiness: (id: string) => api.post(`${base}/fiware/sync/business/${id}`),
  bulkSync: (limit = 50) => api.post(`${base}/fiware/sync/all`, null, { params: { limit } }),
};
